import getNative from './_getNative.js';
import root from './_root.js';
'use strict';
/* Built-in method references that are verified to be native. */


var DataView = getNative(root, 'DataView');
export default DataView;